import i18n from 'i18next';

const ReceiveMethodEnum = {
  EATIN: 0,
  TAKEOUT: 1,
  DELIVERY: 2,
  properties: {
    0: { name: i18n.t('order.label.eatIn'), code: 'BS104' },
    1: { name: i18n.t('order.label.takeOut'), code: 'BS103' },
    2: { name: i18n.t('order.label.delivery'), code: 'BS105' },
  },
};

export default ReceiveMethodEnum;
